module.exports = __webpack_public_path__ + "img/horizontal_7_6_pp3_6005.2b10d4ae.png";